import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export type Database = {
  public: {
    Tables: {
      semesters: {
        Row: {
          id: number
          name: string
          season: string
          year: number
          is_active: boolean | null
          created_at: string
        }
        Insert: {
          id?: number
          name: string
          season: string
          year: number
          is_active?: boolean | null
          created_at?: string
        }
        Update: {
          id?: number
          name?: string
          season?: string
          year?: number
          is_active?: boolean | null
          created_at?: string
        }
      }
      families: {
        Row: {
          id: number
          join_date: string | null
          status: string | null
          last_name: string
          first_name: string
          combined_name: string
          address: string | null
          email: string
          phone_number: string | null
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: number
          join_date?: string | null
          status?: string | null
          last_name: string
          first_name: string
          combined_name: string
          address?: string | null
          email: string
          phone_number?: string | null
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: number
          join_date?: string | null
          status?: string | null
          last_name?: string
          first_name?: string
          combined_name?: string
          address?: string | null
          email?: string
          phone_number?: string | null
          created_at?: string
          updated_at?: string
        }
      }
      students: {
        Row: {
          id: number
          student_id: number | null
          family_name: string
          first_name: string
          combined_name: string
          address: string | null
          phone_number: string | null
          home_country: string | null
          email: string
          gender: string | null
          marital_status: string | null
          major: string | null
          program_level: string | null
          special_interests: string | null
          has_dietary_restrictions: boolean | null
          dietary_restrictions_details: string | null
          willing_to_share: boolean | null
          vaccination_status: string | null
          semester_year: string | null
          semester_id: number | null
          time_submitted: string | null
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: number
          student_id?: number | null
          family_name: string
          first_name: string
          combined_name: string
          address?: string | null
          phone_number?: string | null
          home_country?: string | null
          email: string
          gender?: string | null
          marital_status?: string | null
          major?: string | null
          program_level?: string | null
          special_interests?: string | null
          has_dietary_restrictions?: boolean | null
          dietary_restrictions_details?: string | null
          willing_to_share?: boolean | null
          vaccination_status?: string | null
          semester_year?: string | null
          semester_id?: number | null
          time_submitted?: string | null
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: number
          student_id?: number | null
          family_name?: string
          first_name?: string
          combined_name?: string
          address?: string | null
          phone_number?: string | null
          home_country?: string | null
          email?: string
          gender?: string | null
          marital_status?: string | null
          major?: string | null
          program_level?: string | null
          special_interests?: string | null
          has_dietary_restrictions?: boolean | null
          dietary_restrictions_details?: string | null
          willing_to_share?: boolean | null
          vaccination_status?: string | null
          semester_year?: string | null
          semester_id?: number | null
          time_submitted?: string | null
          created_at?: string
          updated_at?: string
        }
      }
      assignments: {
        Row: {
          id: number
          family_id: number | null
          student_id: number | null
          semester: string
          semester_id: number | null
          family_email_sent_at: string | null
          student_email_sent_at: string | null
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: number
          family_id?: number | null
          student_id?: number | null
          semester?: string
          semester_id?: number | null
          family_email_sent_at?: string | null
          student_email_sent_at?: string | null
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: number
          family_id?: number | null
          student_id?: number | null
          semester?: string
          semester_id?: number | null
          family_email_sent_at?: string | null
          student_email_sent_at?: string | null
          created_at?: string
          updated_at?: string
        }
      }
      family_availability: {
        Row: {
          id: number
          family_id: number
          semester_id: number
          max_students: number
          preferences_notes: string | null
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: number
          family_id: number
          semester_id: number
          max_students?: number
          preferences_notes?: string | null
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: number
          family_id?: number
          semester_id?: number
          max_students?: number
          preferences_notes?: string | null
          created_at?: string
          updated_at?: string
        }
      }
      email_templates: {
        Row: {
          id: number
          semester_id: number
          template_type: 'family' | 'student'
          subject: string
          body: string
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: number
          semester_id: number
          template_type: 'family' | 'student'
          subject?: string
          body?: string
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: number
          semester_id?: number
          template_type?: 'family' | 'student'
          subject?: string
          body?: string
          created_at?: string
          updated_at?: string
        }
      }
    }
  }
}